// src/common/context/GlobalContext.js
import React, { createContext, useContext, useState } from "react";

const GlobalContext = createContext(null);

export const GlobalProvider = ({ children }) => {
  // 전역 JSON (원하는 구조로 초기값 지정 가능)
  const [globalData, setGlobalData] = useState({});

  return (
    <GlobalContext.Provider value={{ globalData, setGlobalData }}>
      {children}
    </GlobalContext.Provider>
  );
};

// 3️⃣ 전역 데이터 쉽게 가져오기 위한 훅
export const useGlobal = () => useContext(GlobalContext);
